<div class="recommendation-filter-header" *ngIf="!compactLayout">
  <bringoz-icon iconName="notifications"></bringoz-icon>
  <span class="notifications-text br-body-2">{{ 'Notifications' | translate }}</span>
  <!-- <span class="filter-text br-caption-1">Filter rows with recommendations</span> -->
  <bringoz-icon fill="blue" iconName="star-blue"></bringoz-icon>
  <span class="recommendations-count br-body-2">{{ 'Recommendations' | translate }}</span>
  <bringoz-button type="tertiary"
                  size="fit"
                  class="expand-button"
                  [appBringozIdGenerator]="panelOpenedAnalyticsId"
                  (onClick)="onExpandClick($event)">
    <bringoz-icon iconName="expand"></bringoz-icon>
  </bringoz-button>
</div>

<div class="recommendation-filter-header compact" *ngIf="compactLayout">
  <bringoz-button type="fit"
                  size="sm"
                  class="expand-button"
                  [appBringozIdGenerator]="panelOpenedAnalyticsId"
                  (onClick)="onExpandClick($event)">
    <bringoz-icon fill="white" iconName="star-blue"></bringoz-icon>
  </bringoz-button>
</div>
